import { AutoComplete, Button, DatePicker, Form, Input, Select } from "antd";
import React, { createRef, useEffect, useRef, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import AddButton from "../../../../Componets/Buttons/add";
import { select_id, select_search } from "../../../../Controllers/Global";
import dayjs from "dayjs";
import moment from "moment";
import taxes from "../../../taxes.json";
import payment_types from "../../../../Data/billing_payment_types.json";
import Error from "../../../../Componets/Error";
import Modalcomponent from "../../../../Componets/Modal";
import { get_inventory } from "../../../../Controllers/Inventory/Batch";
import { get_product } from "../../../../Controllers/Products/Products";
import TextArea from "antd/es/input/TextArea";
import { create_customer } from "../../../../Controllers/Customers";
import formatDateDDMMYYYY from "../../../../Main/formatDate";

const BillingTable = React.forwardRef((props, focus) => {
  const {
    details,
    setDetails,
    totals,
    setTotals,
    customer,
    setCustomer,
    reference,
    setReference,
    customerPay,
    setCustomerPay,
  } = props;

  focus.current[`delivery_date`] = createRef();
  focus.current[`payment_types`] = createRef();

  const searchTimers = useRef({});

  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [selectedModalData, setSelectedModalData] = useState();

  const [customerName, setCustomerName] = useState();
  const [customerPhone, setCustomerPhone] = useState();
  const [customerOptions, setCustomerOptions] = useState();
  const [referenceOptions, setReferenceOptions] = useState();

  const handleCustomerPay = (e) => {
    setCustomerPay(e?.target?.value);
  };

  const handleSearchProducts = async (e, index) => {
    let data = [...details];

    const select = {
      api: "get-all-products",
      search: e,
      status: 1,
    };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];
      search?.data?.data?.map((value, index) => {
        options?.push({
          value: value?._id,
          label: value?.name,
        });
      });

      data[index].product_options = options;

      setDetails(data);
    } else {
      toast?.error(search?.message);
    }
  };

  const handleProductDescription = async (e, index) => {
    let data = [...details];

    if (e) {
      const product = await get_product({
        id: e,
      });

      if (product) {
        if (product?.data?.type) {
          data[index].product = product?.data?._id;
          data[index].product_details = product?.data;

          setDetails(data);
        } else {
          let product_ids = [];
          data?.map((v, i) => {
            product_ids?.push(v?.product);
          });

          if (!product_ids?.includes(e)) {
            data[index].product = product?.data?._id;
            data[index].product_details = product?.data;
          } else {
            data[index].product = null;
            data[index].product_details = "";

            let selected_index = product_ids?.indexOf(e);

            setTimeout(() => {
              focus.current[`quantity${selected_index}`].current.focus();
            }, 500);
          }

          setDetails(data);
        }
      } else {
        data[index].product = null;
        data[index].product_details = "";
        toast?.error("Product not found");
      }
    }
  };

  // const handleSearch = async (e, index) => {
  //   let data = [...details];

  //   const select = {
  //     api: "get-all-inventories",
  //     search: e,
  //     status: 1,
  //   };

  //   const search = await select_search(select);

  //   if (search?.status) {
  //     let options = [];
  //     search?.data?.data?.map((value, index) => {
  //       options?.push({
  //         value: value?._id,
  //         label: (
  //           <div>
  //             <div>{value?.product?.name}</div>
  //             <div>
  //               {value?.sale_price
  //                 ? `OMR ${value?.sale_price?.toFixed(3)} `
  //                 : "OMR 0.000"}
  //               {` (#BATCH-${value?.number})`}
  //             </div>
  //             {value?.expiry_date ? (
  //               <div>
  //                 EXPIRY :{" "}
  //                 {moment?.(value?.expiry_date)?.format?.("DD-MM-YYYY")}
  //               </div>
  //             ) : (
  //               ""
  //             )}
  //           </div>
  //         ),
  //       });
  //     });

  //     data[index].options = options;

  //     setDetails(data);
  //   } else {
  //     toast?.error(search?.message);
  //   }
  // };

  const latestQueryRef = useRef({});

  const handleSearch = (query, index) => {
    if (searchTimers.current[index]) {
      clearTimeout(searchTimers.current[index]);
    }

    searchTimers.current[index] = setTimeout(async () => {
      let data = [...details];

      latestQueryRef.current[index] = query; // track per input

      const select = {
        api: "get-all-inventories",
        search: query,
        status: 1,
        sort: 7
      };

      const search = await select_search(select);

      if (latestQueryRef.current[index] !== query) return;

      if (search?.status) {
        const options = search.data.data.map((value) => ({
          data: value,
          value: value?._id,
          label: (
            <div>
              <div>{value?.product?.name}</div>
              <div>
                {value?.sale_price
                  ? `OMR ${value?.sale_price?.toFixed(3)} `
                  : "OMR 0.000"}
                {` (#BATCH-${value?.number})`}
              </div>
              {value?.expiry_date && (
                <div>
                  EXPIRY : {formatDateDDMMYYYY(value?.expiry_date)}
                </div>
              )}
            </div>
          ),
        }));

        data[index].options = options;
        setDetails(data);
      } else {
        toast?.error(search?.message);
      }
    }, 300);
  };

  const handleModal = (modaldata) => {
    let data = [...details];

    let inventory = selectedModalData;
    let index = selectedModalData?.index;

    let inventory_description = null;
    let inventory_name = "";
    let inventory_batch = "";
    let inventory_expiry_date = "";
    let inventory_price_per_unit = "";
    let inventory_unit = "";
    let inventory_unit_name = "";
    let inventory_sale_price = 0;
    let inventory_retail_price = 0;
    let inventory_stock = 0;
    let inventory_tax = 0;
    let inventory_conversion = 0;
    let inventory_unit_details = [];

    let description_ids = [];

    data?.map((v, i) => {
      description_ids?.push(v?.unit);
    });

    if (!description_ids?.includes(modaldata)) {
      if (inventory?.data?._id == modaldata) {
        inventory_description = inventory?.data?._id;
        inventory_name = inventory?.data?.product?.name;
        inventory_batch = inventory?.data?.number;
        inventory_expiry_date = inventory?.data?.expiry_date;
        inventory_price_per_unit = inventory?.data?.price_per_unit;
        inventory_unit = modaldata;
        inventory_unit_name = inventory?.data?.product?.unit?.name;
        inventory_sale_price = inventory?.data?.sale_price
          ? inventory?.data?.sale_price
          : inventory?.data?.sale_price;
        inventory_retail_price = inventory?.data?.sale_price;
        inventory_stock = inventory?.data?.stock;
        inventory_tax = inventory?.data?.tax;

        if (inventory?.data?.inventory_unit_details?.length > 0) {
          inventory?.data?.inventory_unit_details?.map((value, index) => {
            inventory_unit_details?.push({
              ...value,
              name: value?.name,
              purchase_price: value?.purchase_price,
              price_per_unit: value?.price_per_unit,
              sale_price: value?.sale_price,
              stock: value?.stock,
              unit_quantity: 0,
              unit_delivered: 0,
            });
          });
        }
      } else {
        let selected_unit = "";
        let unit_ids = [];

        if (inventory?.data?.inventory_unit_details?.length > 0) {
          inventory?.data?.inventory_unit_details?.map((value, index) => {
            unit_ids?.push(value?._id);
          });
        }

        if (unit_ids?.includes(modaldata)) {
          selected_unit =
            inventory?.data?.inventory_unit_details?.[
            unit_ids?.indexOf(modaldata)
            ];
        }

        inventory_description = inventory?.data?._id;
        inventory_name = inventory?.data?.product?.name;
        inventory_batch = inventory?.data?.number;
        inventory_expiry_date = inventory?.data?.expiry_date;
        inventory_unit = modaldata;
        inventory_unit_name = selected_unit?.name;
        inventory_sale_price = selected_unit?.sale_price;
        inventory_stock = selected_unit?.stock;
        inventory_tax = inventory?.data?.tax;
        inventory_conversion = selected_unit?.conversion;
      }

      data[index].description = inventory_description;
      data[index].name = inventory_name;
      data[index].batch = inventory_batch;
      data[index].expiry_date = inventory_expiry_date;
      data[index].unit = inventory_unit;
      data[index].unit_name = inventory_unit_name;
      data[index].quantity = "";
      data[index].sale_price = inventory_sale_price;
      data[index].retail_price = inventory_retail_price;
      data[index].stock = inventory_stock;
      data[index].tax = inventory_tax;
      data[index].conversion = inventory_conversion;
      data[index].unit_details_options = inventory_unit_details;

      focus.current[`quantity${index}`].current.focus();

      setDetails(data);
      setModalData();
      setSelectedModalData();
    } else {
      // let selected_index = description_ids?.indexOf(inventory?.data?._id);
      let selected_index = description_ids?.indexOf(modaldata);

      if (
        parseFloat(data[selected_index].quantity || 0) <
        parseFloat(data[selected_index].stock || 0)
      ) {
        let quantity = data[selected_index].quantity
          ? data[selected_index].quantity
          : 0;

        if (
          data?.[selected_index]?.conversion > 0 &&
          data?.[selected_index]?.quantity + parseFloat(1) >=
          data?.[selected_index]?.conversion
        ) {
          toast?.error(
            `Quantity exceeding ${data?.[selected_index]?.conversion}`
          );
        } else {
          setTimeout(() => {
            focus.current[`quantity${selected_index}`].current.focus();
          }, 500);

          // data[selected_index].quantity = parseFloat(quantity) + parseFloat(1);
          // data[selected_index].delivered = parseFloat(quantity) + parseFloat(1);
        }

        setDetails(data);
        setModalData();
        setSelectedModalData();
      } else {
        toast?.error(`Stock only ${data[selected_index].stock}`);
      }
    }
  };

  const handleDescription = async (e, index, inventories_data) => {
    let data = [...details];

    if (e) {
      let params = {
        id: e,
      };

      // const inventory = await get_inventory(params);

      const inventory = {
        status: true,
        data: {
          ...inventories_data?.data,
          inventory_unit_details:
            inventories_data?.data?.inventories_units_details,
        },
      };

      if (inventory?.status) {
        if (
          inventory?.data?.expiry_date &&
          new Date(new Date(inventory?.data?.expiry_date).getTime()) <
          new Date()
        ) {
          toast?.error(
            `Inventory expired on ${formatDateDDMMYYYY(
              inventory?.data?.expiry_date
            )}`
          );
        } else {
          if (inventory?.data?.inventory_unit_details?.length > 0) {
            setOpen(true);

            let modaldata = [
              {
                ...inventory?.data,
                name: inventory?.data?.product?.unit?.name,
              },
            ];

            inventory?.data?.inventory_unit_details?.map((v, i) => {
              modaldata?.push(v);
            });

            setModalData(modaldata);

            setSelectedModalData({ ...inventory, index: index });
          } else {
            let description_ids = [];

            data?.map((v, i) => {
              description_ids?.push(v?.description);
            });

            if (!description_ids?.includes(e)) {
              let inventory_description = inventory?.data?._id;
              let inventory_name = inventory?.data?.product?.name;
              let inventory_batch = inventory?.data?.number;
              let inventory_expiry_date = inventory?.data?.expiry_date;
              let inventory_unit = inventory?.data?._id;
              let inventory_unit_name = inventory?.data?.product?.unit?.name;
              let inventory_sale_price = inventory?.data?.sale_price
                ? inventory?.data?.sale_price
                : inventory?.data?.sale_price;
              let inventory_retail_price = inventory?.data?.sale_price;
              let inventory_stock = inventory?.data?.stock;
              let inventory_tax = inventory?.data?.tax;

              let inventory_unit_details = [];
              if (inventory?.data?.inventory_unit_details?.length > 0) {
                inventory?.data?.inventory_unit_details?.map((value, index) => {
                  inventory_unit_details?.push({
                    ...value,
                    name: value?.name?.name,
                    price_per_unit: 0,
                    sale_price: "",
                    unit_quantity: 0,
                    unit_delivered: 0,
                  });
                });
              }

              data[index].description = inventory_description;
              data[index].name = inventory_name;
              data[index].batch = inventory_batch;
              data[index].expiry_date = inventory_expiry_date;
              data[index].unit = inventory_unit;
              data[index].unit_name = inventory_unit_name;
              data[index].sale_price = inventory_sale_price;
              data[index].retail_price = inventory_retail_price;
              data[index].stock = inventory_stock;
              data[index].tax = inventory_tax;
              data[index].quantity = "";
              data[index].unit_details_options = inventory_unit_details;
              setDetails(data);

              focus.current[`quantity${index}`].current.focus();
            } else {
              let selected_index = description_ids?.indexOf(e);

              if (
                parseFloat(data[selected_index].quantity || 0) <
                parseFloat(data[selected_index].stock || 0)
              ) {
                let quantity = data[selected_index].quantity
                  ? data[selected_index].quantity
                  : 0;
                let delivered = data[selected_index].delivered
                  ? data[selected_index].delivered
                  : 0;

                setTimeout(() => {
                  focus.current[`quantity${selected_index}`].current.focus();
                }, 500);

                // data[selected_index].quantity =
                //   parseFloat(quantity) + parseFloat(1);
                // data[selected_index].delivered =
                //   parseFloat(delivered) + parseFloat(1);

                setDetails(data);
              } else {
                toast?.error(`Stock only ${data[selected_index].stock}`);
              }
            }
          }
        }
      } else {
        toast?.error("Inventory not found");
      }
    } else {
      data[index].id = "";
      data[index].product = null;
      data[index].description = null;
      data[index].name = "";
      data[index].batch = "";
      data[index].expiry_date = "";
      data[index].unit = "";
      data[index].unit_name = "";
      data[index].unit_details_options = null;
      data[index].quantity = "";
      data[index].conversion = 0;
      data[index].purchase = "";
      data[index].sale_price = "";
      data[index].purchase_options = null;
      data[index].delivered = "";
      data[index].tax = 0;
      data[index].free = "";
      data[index].barcode = "";
      data[index].price_per_unit = "";
      data[index].sale_price = "";
      data[index].expiry_date = "";
      data[index].tax_amount = "0.000";
      data[index].total = 0;
      setDetails(data);
    }
  };

  const handlePurchasePriceSearch = async (e, index) => {
    let data = [...details];

    if (data[index].description) {
      const select = {
        api: "get-all-purchase-details",
        id: data[index].description,
      };

      const search = await select_id(select);
      if (search?.status) {
        let options = [];
        search?.data?.map((value, index) => {
          options?.push({
            value: JSON?.stringify(value),
            label:
              "" +
              value?.price_per_unit?.toFixed(3) +
              " (" +
              value?.purchase?.supplier?.name +
              ", " +
              formatDateDDMMYYYY(value?.purchase?.date) +
              ", #PO" +
              value?.purchase?.number +
              ")",
          });
        });

        data[index].purchase_options = options;
        setDetails(data);
      } else {
        toast?.error(search?.message);
      }
    }
  };

  const handleTotal = (e, index, key) => {
    let name = key ? key : e?.target?.name;
    let value = key && e ? e : !key && e?.target?.value ? e?.target?.value : "";

    if (value >= 0) {
      let data = [...details];

      console.log(
        parseFloat(value || 0) + parseFloat(data[index]?.free || 0),
        "value",
        parseFloat(value || 0),
        "alll",
        parseFloat(data[index]?.free || 0)
      );

      if (
        parseFloat(value || 0) <= parseFloat(data[index]?.stock || 0) ||
        name == "sale_price"
      ) {
        if (
          name == "free" &&
          parseFloat(value || 0) + parseFloat(data[index]?.quantity || 0) >
          parseFloat(data[index]?.stock || 0)
        ) {
          toast?.error(`Stock only ${data[index]?.stock}`);
        } else {
          let data_sale_price = data[index]?.sale_price
            ? data[index]?.sale_price
            : 0;
          let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
          let data_deliverd = data[index]?.delivered
            ? data[index]?.delivered
            : 0;
          let data_free = data[index]?.free ? data[index]?.free : 0;
          let data_tax = data[index]?.tax ? data[index]?.tax : 0;
          let data_conversion = data[index].conversion
            ? data[index].conversion
            : 0;

          let sale_price = name === "sale_price" ? value : data_sale_price;
          let quantity = name === "quantity" ? value : data_quantity;
          let delivered = name === "quantity" ? value : data_deliverd;
          let free = name === "free" ? value : data_free;
          let tax = name === "tax" ? value : data_tax;

          let tax_amount = tax
            ? parseFloat(sale_price) *
            parseFloat(quantity ? quantity : 0) *
            (parseFloat(tax) / 100)
            : 0;

          let total =
            parseFloat(sale_price) * parseFloat(quantity ? quantity : 0) +
            parseFloat(tax_amount);

          let price_per_unit =
            parseFloat(total ? total : 0) /
            (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

          let unit_details_options = [];
          if (data?.[index]?.unit_details_options?.length > 0) {
            data?.[index]?.unit_details_options?.map((v, i) => {
              let total_quantity =
                parseFloat(quantity || 0) + parseFloat(free || 0);

              unit_details_options?.push({
                ...v,
                //price_per_unit
                price_per_unit: price_per_unit
                  ? parseFloat(price_per_unit || 0) /
                  parseFloat(v?.conversion || 0)
                  : 0,
                //unit_quantity
                unit_quantity: quantity
                  ? parseFloat(v?.conversion || 0) *
                  parseFloat(total_quantity || 0)
                  : 0,
                //unit_deliverd
                unit_delivered: delivered
                  ? parseFloat(v?.conversion || 0) *
                  parseFloat(total_quantity || 0)
                  : 0,
              });
            });
          }

          if (
            data_conversion > 0 &&
            parseFloat(quantity) + parseFloat(free) >= ((data_conversion) * data[index]?.stock)
          ) {
            toast?.error(`Quantity exceeding ${data[index].conversion}`);
          } else {
            data[index][name] = value;
            data[index].unit_details_options = unit_details_options;
            // data[index].delivered = delivered ? delivered : "";
            data[index].delivered =
              parseFloat(quantity || 0) + parseFloat(free || 0);
            data[index].tax = tax ? tax : 0;
            data[index].total = total ? total : 0;
            data[index].tax_amount = tax_amount ? tax_amount : "0.000";
            data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

            let subtotal =
              data?.reduce(
                (acc, currentValue) =>
                  parseFloat(acc) + parseFloat(currentValue?.total),
                0
              ) -
              data?.reduce(
                (acc, currentValue) =>
                  parseFloat(acc) + parseFloat(currentValue?.tax_amount),
                0
              );

            let taxamount = data?.reduce(
              (acc, currentValue) =>
                parseFloat(acc) + parseFloat(currentValue?.tax_amount),
              0
            );

            let grandtotal =
              data?.reduce(
                (acc, currentValue) =>
                  parseFloat(acc) + parseFloat(currentValue?.total),
                0
              ) +
              parseFloat(totals?.delivery || 0) -
              parseFloat(totals?.discount || 0);

            totals.subtotal = subtotal;
            totals.taxamount = taxamount;
            // totals.delivery_status = 0;
            // totals.delivery_date = "";
            // totals.payment_status = 0;
            // totals.payment_types = null;
            // totals.payments = {
            //   Cash: "",
            //   Cheque: "",
            //   "Debit card": "",
            //   "Credit card": "",
            //   "Bank transfer": "",
            //   "Online payment": "",
            // };
            totals.total = grandtotal;

            setDetails(data);
            setTotals({ ...totals });
          }
        }
      } else {
        toast?.error(`Stock only ${data[index]?.stock}`);
      }
    }
  };

  const handleChange = (e, index, key) => {
    let data = [...details];

    data[index][e?.target?.name] = e?.target?.value;
    setDetails(data);
  };

  const handleSalePrice = (e, index) => {
    if (e?.target?.value >= 0) {
      let data = [...details];

      data[index].sale_price = e?.target?.value;

      if (data[index]?.unit_details_options?.length > 0) {
        data[index]?.unit_details_options?.map((v, i) => {
          data[index].unit_details_options[i].sale_price = (
            parseFloat(e?.target?.value) / parseFloat(v?.conversion)
          )?.toFixed(3);
        });
      }

      setDetails(data);
    }
  };

  const handleUnitSalePrice = (e, index, i) => {
    let data = [...details];

    let name = e?.target?.name;
    let value = e?.target?.value;

    if (name) {
      if (value >= 0) {
        data[index].unit_details_options[i].sale_price = value;
        setDetails(data);
      }
    }
  };

  const handleDate = (e, index, name) => {
    let data = [...details];
    data[index][name] = e?.$d;

    setDetails(data);
  };

  const handleDelivered = (e, index) => {
    let data = [...details];

    let data_delivered = e?.target?.value ? parseFloat(e?.target?.value) : 0;

    let data_quantity = data[index]?.quantity
      ? parseFloat(data[index]?.quantity)
      : 0;
    let data_free = data[index]?.free ? parseFloat(data[index]?.free) : 0;
    let total_quantity =
      parseFloat(data_quantity || 0) + parseFloat(data_free || 0);

    if (data_delivered >= 0) {
      if (data_delivered <= total_quantity) {
        let unit_details_options = [];
        if (data?.[index]?.unit_details_options?.length > 0) {
          data?.[index]?.unit_details_options?.map((v, i) => {
            unit_details_options?.push({
              ...v,
              //delivered_stcok
              unit_delivered: data_delivered
                ? parseFloat(data_delivered) * parseFloat(v?.conversion)
                : 0,
            });
          });
        }

        data[index][e?.target?.name] = e?.target?.value;
        data[index].unit_details_options = unit_details_options;

        setDetails(data);
      } else {
        toast?.error(`Quantity only ${total_quantity}`);
      }
    }
  };

  const handleRemove = (index) => {
    let name = "quantity";
    let value = 0;

    // if (value >= 0) {
    let data = [...details];

    // if (value <= data[index]?.stock) {
    let data_sale_price = data[index]?.sale_price ? data[index]?.sale_price : 0;
    let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
    let data_deliverd = data[index]?.delivered ? data[index]?.delivered : 0;
    let data_free = data[index]?.free ? data[index]?.free : 0;
    let data_tax = data[index]?.tax ? data[index]?.tax : 0;
    let data_conversion = data[index].conversion ? data[index].conversion : 0;

    let sale_price = name === "sale_price" ? value : data_sale_price;
    let quantity = name === "quantity" ? value : data_quantity;
    let delivered = name === "quantity" ? value : data_deliverd;
    let free = name === "free" ? value : data_free;
    let tax = name === "tax" ? value : data_tax;

    let tax_amount = tax
      ? parseFloat(sale_price) *
      parseFloat(quantity ? quantity : 0) *
      (parseFloat(tax) / 100)
      : 0;

    let total =
      parseFloat(sale_price) * parseFloat(quantity ? quantity : 0) +
      parseFloat(tax_amount);

    let price_per_unit =
      parseFloat(total ? total : 0) /
      (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

    let unit_details_options = [];
    if (data?.[index]?.unit_details_options?.length > 0) {
      data?.[index]?.unit_details_options?.map((v, i) => {
        let total_quantity = parseFloat(quantity || 0) + parseFloat(free || 0);

        unit_details_options?.push({
          ...v,
          //price_per_unit
          price_per_unit: price_per_unit
            ? parseFloat(price_per_unit || 0) / parseFloat(v?.conversion || 0)
            : 0,
          //unit_quantity
          unit_quantity: quantity
            ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
            : 0,
          //unit_deliverd
          unit_delivered: delivered
            ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
            : 0,
        });
      });
    }

    if (
      data_conversion > 0 &&
      parseFloat(quantity) + parseFloat(free) >= data_conversion
    ) {
      toast?.error(`Quantiy exceeding ${data[index].conversion}`);
    } else {
      data[index][name] = value;
      data[index].unit_details_options = unit_details_options;
      data[index].delivered = delivered ? delivered : "";
      data[index].tax = tax ? tax : 0;
      data[index].total = total ? total : 0;
      data[index].tax_amount = tax_amount ? tax_amount : "0.000";
      data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

      let subtotal =
        data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0
        ) -
        data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.tax_amount),
          0
        );

      let taxamount = data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.tax_amount),
        0
      );

      let grandtotal =
        data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0
        ) +
        parseFloat(totals?.delivery || 0) -
        parseFloat(totals?.discount || 0);

      totals.subtotal = subtotal;
      totals.taxamount = taxamount;
      // totals.delivery_status = 0;
      // totals.delivery_date = "";
      // totals.payment_status = 0;
      // totals.payment_types = null;
      // totals.payments = {
      //   Cash: "",
      //   Cheque: "",
      //   "Debit card": "",
      //   "Credit card": "",
      //   "Bank transfer": "",
      //   "Online payment": "",
      // };
      totals.total = grandtotal;

      data?.splice(index, 1);
      setDetails(data);
      setTotals({ ...totals });
    }
    // } else {
    //   toast?.error(`Stock only ${data[index]?.stock}`);
    // }
    // }
  };

  const handleAdd = () => {
    setDetails((prevDetails) => [
      ...prevDetails,
      {
        id: "",
        description: null,
        name: "",
        unit: "",
        unit_name: "",
        unit_details_options: null,
        quantity: "",
        purchase: "",
        sale_price: "",
        purchase_options: null,
        delivered: "",
        tax: 0,
        free: "",
        barcode: "",
        price_per_unit: "",
        sale_price: "",
        expiry_date: "",
        tax_amount: "0.000",
        total: 0,
      },
    ]);

    setTimeout(() => {
      focus.current[`description${details?.length}`].current.focus();
    }, 100);
  };

  const handleDelivery = (e) => {
    if (e?.target?.value >= 0) {
      let total_amount = parseFloat(
        details?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0
        )
      );

      let total =
        parseFloat(total_amount ? total_amount : 0) +
        parseFloat(e?.target?.value ? e?.target?.value : 0) -
        parseFloat(totals?.discount ? totals?.discount : 0);

      totals.delivery = e?.target?.value;
      totals.total = total;

      setTotals({ ...totals });
    }
  };

  const handleDiscount = (e) => {
    if (e?.target?.value >= 0) {
      let total_amount = parseFloat(
        details?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0
        )
      );

      let total =
        parseFloat(total_amount ? total_amount : 0) +
        parseFloat(totals?.delivery ? totals?.delivery : 0) -
        parseFloat(e?.target?.value ? e?.target?.value : 0);

      if (e?.target?.value <= total_amount) {
        totals.discount = e?.target?.value;
        totals.total = total;
      } else {
        toast?.error(`Total amount ${total_amount}`);
      }

      setTotals({ ...totals });
    }
  };

  const handleDeliveryStatus = (e) => {
    totals.delivery_status = e;

    if (!e) {
      totals.delivery_date = "";
    } else if (e == 1) {
      totals.delivery_date = "";
    }

    setTotals({ ...totals });
  };

  const handleDeliveryDate = (e) => {
    totals.delivery_date = e?.$d;
    setTotals({ ...totals });
  };

  const handlePaymentStatus = (e) => {
    totals.payment_status = e;

    if (!e) {
      totals.payment_types = null;
    }
    setTotals({ ...totals });
  };

  const handlePaymentTypes = (e) => {
    totals?.payment_types?.map((v, i) => {
      if (!e?.includes(v)) {
        totals.payments[v] = "";
      }
    });

    totals.payment_types = e;

    setTotals({ ...totals });
  };

  const handlePayments = (e) => {
    let name = e?.target?.name;
    let value = e?.target?.value ? e?.target?.value : "";

    if (e?.target?.value >= 0) {
      let data_Cash = totals?.payments?.Cash?.amount
        ? totals?.payments?.Cash?.amount
        : 0;
      let data_Cheque = totals?.payments?.Cheque?.amount
        ? totals?.payments?.Cheque?.amount
        : 0;
      let data_Debitcard = totals?.payments?.["Debit card"]?.amount
        ? totals?.payments?.["Debit card"]?.amount
        : 0;
      let data_Creditcard = totals?.payments?.["Credit card"]?.amount
        ? totals?.payments?.["Credit card"]?.amount
        : 0;
      let data_Banktransfer = totals?.payments?.["Bank transfer"]?.amount
        ? totals?.payments?.["Bank transfer"]?.amount
        : 0;
      let data_Onlinepayment = totals?.payments?.["Online payment"]?.amount
        ? totals?.payments?.["Online payment"]?.amount
        : 0;

      let Cash = name === "Cash" ? value : data_Cash;
      let Cheque = name === "Cheque" ? value : data_Cheque;
      let Debitcard = name === "Debit card" ? value : data_Debitcard;
      let Creditcard = name === "Credit card" ? value : data_Creditcard;
      let Banktransfer = name === "Bank transfer" ? value : data_Banktransfer;
      let Onlinepayment =
        name === "Online payment" ? value : data_Onlinepayment;

      let total =
        parseFloat(Cash) +
        parseFloat(Cheque) +
        parseFloat(Debitcard) +
        parseFloat(Creditcard) +
        parseFloat(Banktransfer) +
        parseFloat(Onlinepayment);

      let payment_total = total ? parseFloat(total) : 0;
      let grand_total = totals?.total ? parseFloat(totals?.total) : 0;

      if (
        parseFloat(payment_total?.toFixed(3) || 0) <=
        parseFloat(grand_total?.toFixed(3) || 0)
      ) {
        totals.payments[name] = { ...totals.payments[name], amount: value };

        let payment_grand_total =
          parseFloat(totals.payments["Cash"].amount || 0) +
          parseFloat(totals.payments["Cheque"].amount || 0) +
          parseFloat(totals.payments["Debit card"].amount || 0) +
          parseFloat(totals.payments["Credit card"].amount || 0) +
          parseFloat(totals.payments["Bank transfer"].amount || 0) +
          parseFloat(totals.payments["Online payment"].amount || 0);
        totals.pending_payment =
          parseFloat(grand_total || 0) - parseFloat(payment_grand_total || 0);

        setTotals({ ...totals });
        console.log(grand_total, "grand_total - 1", payment_total);
      } else {
        let previous_total =
          parseFloat(data_Cash) +
          parseFloat(data_Cheque) +
          parseFloat(data_Debitcard) +
          parseFloat(data_Creditcard) +
          parseFloat(data_Banktransfer) +
          parseFloat(data_Onlinepayment);

        totals.payments[name] = { ...totals.payments[name], amount: "" };

        let payment_grand_total =
          parseFloat(totals.payments["Cash"].amount || 0) +
          parseFloat(totals.payments["Cheque"].amount || 0) +
          parseFloat(totals.payments["Debit card"].amount || 0) +
          parseFloat(totals.payments["Credit card"].amount || 0) +
          parseFloat(totals.payments["Bank transfer"].amount || 0) +
          parseFloat(totals.payments["Online payment"].amount || 0);
        totals.pending_payment =
          parseFloat(grand_total || 0) - parseFloat(payment_grand_total || 0);

        setTotals({ ...totals });

        // let previous_remaining_amount =
        //   parseFloat(grand_total) - parseFloat(previous_total);

        let previous_remaining_amount =
          parseFloat(grand_total || 0) - parseFloat(payment_grand_total || 0);

        toast?.error(`Pending only ${previous_remaining_amount?.toFixed?.(3)}`);
      }
    }
  };

  const handleCustomerSearch = async (e) => {
    const select = {
      api: "get-all-customers",
      search: e,
      status: 1,
    };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];
      search?.data?.data?.map((value, index) => {
        options?.push({
          value: value?._id,
          label: (
            <div>
              {value?.name}
              &nbsp;{value?.phone ? "(" + value?.phone + ")" : ""}
            </div>
          ),
        });
      });

      setCustomerOptions(options);
    } else {
      toast?.error(search?.message);
    }
  };

  const handleReferenceSearch = async (e) => {
    const select = {
      api: "get-all-references",
      search: e,
      status: 1,
    };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];
      search?.data?.data?.map((value, index) => {
        options?.push({
          value: value?._id,
          label: (
            <div>
              {value?.name}
              &nbsp;{value?.phone ? "(" + value?.phone + ")" : ""}
            </div>
          ),
        });
      });

      setReferenceOptions(options);
    } else {
      toast?.error(search?.message);
    }
  };

  const handleCustomer = (e) => {
    if (e?.target?.name == "name") {
      setCustomerName(e?.target?.value);
    } else if (e?.target?.name == "phone") {
      setCustomerPhone(e?.target?.value);
    }
  };

  const addCustomer = async (e) => {
    if (customerPhone) {
      let params = {
        name: customerName,
        phone: customerPhone,
        status: 1,
      };

      const addcustomer = await create_customer(params);

      if (addcustomer?.status) {
        toast?.success(addcustomer?.message);
        setCustomerName("");
        setCustomerPhone("");
      } else {
        toast?.error(addcustomer?.message);
      }
    } else {
      toast?.error("Phone Required");
    }
  };

  const dateFormatList = ["DD/MM/YYYY", "DD-MM-YYYY"];

  return (
    <div className="overflow-x-auto">
      <Modalcomponent
        open={open}
        setOpen={setOpen}
        modalData={modalData}
        setModalData={setModalData}
        selectedModalData={selectedModalData}
        setSelectedModalData={setSelectedModalData}
        handleModal={handleModal}
      />
      <table className="w-[100%]">
        <thead>
          <tr>
            <td className="border p-4 text-black">S.NO</td>
            <td className="border p-4 text-black">DESCRIPTION</td>
            <td className="border p-4 text-black">UNIT</td>
            <td className="border p-4 text-black">QUANTITY</td>
            {/* <td className="border p-4 text-black">DELIVERED</td> */}
            <td className="border p-4 text-black">SALE&nbsp;PRICE</td>
            <td className="border p-4 text-black">TAX&nbsp;[VAT]</td>
            <td className="border p-4 text-black">TOTAL</td>
            <td className="border p-4 text-black">DELETE</td>
          </tr>
        </thead>
        <tbody>
          {details?.map((value, index) => {
            focus.current[`description${index}`] = createRef();
            focus.current[`sale_price${index}`] = createRef();
            focus.current[`quantity${index}`] = createRef();
            focus.current[`sale_price${index}`] = createRef();
            return (
              <React.Fragment>
                <tr>
                  <td className="border p-4 text-center text-gray-700">
                    {index + 1}
                  </td>
                  <td className="border p-4">
                    {/* {value?.product ? (
                      <div className="text-black">
                        {value?.product_details?.name}
                      </div>
                    ) : (
                      <div>
                        <Select
                          className="w-[300px] text-regular"
                          name="description"
                          ref={focus.current[`description${index}`]}
                          placeholder="Product"
                          allowClear={true}
                          showSearch={true}
                          filterOption={false}
                          value={value?.product}
                          options={value?.product_options}
                          onSearch={(e) => handleSearchProducts(e, index)}
                          onFocus={(e) => handleSearchProducts("", index)}
                          onClick={(e) => handleSearchProducts("", index)}
                          onChange={(e) => handleProductDescription(e, index)}
                          autoComplete="off"
                        />
                      </div>
                    )} */}
                    <div className="pt-2">
                      {/* {value?.product_details?.type ? ( */}
                      <div>
                        {value?.description ? (
                          <div className="w-[500px]">
                            <div className="text-xs text-gray-900">
                              {value?.name}
                            </div>
                            <div className="text-xs">{`#BATCH-${value?.batch}`}</div>
                            <div className="text-xs">
                              {value?.expiry_date
                                ? `Expiry (${formatDateDDMMYYYY(
                                  value?.expiry_date
                                )})`
                                : ""}
                            </div>
                            <div className="pt-2">
                              <TextArea
                                type="number"
                                className="w-full text-regular"
                                name="summary"
                                placeholder="Summary"
                                value={value?.summary}
                                autoComplete="off"
                                onKeyDown={(e) => {
                                  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                    e.preventDefault();
                                  }
                                }}
                                onWheel={(e) => {
                                  e.target.blur();
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div>
                            <Select
                              className="w-[500px] text-regular"
                              name="description"
                              ref={focus.current[`description${index}`]}
                              placeholder="Description"
                              allowClear={true}
                              showSearch={true}
                              filterOption={false}
                              value={value?.description}
                              options={value?.options}
                              onSearch={(e) => handleSearch(e, index)}
                              onFocus={(e) => handleSearch("", index)}
                              // onClick={(e) => handleSearch("", index)}
                              // onChange={(e) => handleDescription(e, index)}
                              onChange={(value, option) =>
                                handleDescription(value, index, option)
                              }
                              autoComplete="off"
                            />
                          </div>
                        )}
                      </div>
                      {/* ) 
                     : (
                      <div className="pt-2">
                        <TextArea
                          type="number"
                          className="w-full text-regular"
                          name="summary"
                          placeholder="Summary"
                          value={value?.summary}
                          autoComplete="off"
                        />
                      </div>
                      )} */}
                    </div>
                    <Error id={`description${index}`} />
                  </td>
                  <td className="border p-4 text-center">
                    <div>{value?.unit_name}</div>
                  </td>
                  <td className="border p-4">
                    <div className="">
                      <div className="text-xs text-green-500">
                        Stock&nbsp;
                        {/* {value?.product_details?.type   ?*/}
                        {(() => {
                          const stock = Number(value?.stock) || 0;
                          return stock > 0 ? Math.floor(stock) : "0";
                        })()}
                      </div>
                      <Input
                        type="number"
                        className="w-full text-regular pt-2"
                        name="quantity"
                        ref={focus.current[`quantity${index}`]}
                        placeholder="Quantity"
                        value={value?.quantity}
                        onChange={(e) => handleTotal(e, index)}
                        autoComplete="off"
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => {
                          e.target.blur();
                        }}
                      />
                      <div>
                        <Error id={`quantity${index}`} />
                      </div>
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    <div>{value?.sale_price?.toFixed?.(3)}</div>
                  </td>
                  {/* <td className="border p-4 text-center">
                    <Input
                      type="number"
                      className="w-full text-regular"
                      name="delivered"
                      placeholder="Delivered"
                      value={value?.delivered}
                      onChange={(e) => handleDelivered(e, index)}
                      autoComplete="off"
                    />
                  </td> */}
                  <td className="border p-4 text-center">
                    <div>{value?.tax ? value?.tax + "%" : "0%"}</div>
                    <div>
                      {value?.tax_amount
                        ? parseFloat(value?.tax_amount)?.toFixed(3)
                        : "0.000"}
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    {value?.total
                      ? parseFloat?.(value?.total)?.toFixed(3)
                      : "0.000"}
                  </td>
                  <td className="border p-4 text-center">
                    {value?.id ? (
                      <button
                        type="button"
                        className="text-lg text-red-900 cursor-not-allowed	 hover:text-black"
                        disabled={true}
                      >
                        <DeleteOutlined />
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                        onClick={() => handleRemove(index)}
                      >
                        <DeleteOutlined />
                      </button>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-200 border-b-gray-400 p-4 text-center"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4">
                    {/* units details unit_quantity */}
                    <div>
                      {value?.unit_details_options?.map((v, i) => {
                        return (
                          <div className="pt-2">
                            <div className="pb-2">
                              {v?.name}({v?.conversion})
                            </div>
                            <div>
                              <div className="border border-gray-300 p-1 rounded-md">
                                {/* <div>{v?.unit_quantity}</div> */}
                                <div>{v?.unit_delivered}</div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </td>
                  {/* units details unit_delivered */}
                  {/* <td className="border border-gray-200 border-b-gray-400 p-4">
                    <div>
                      {value?.unit_details_options?.map((v, i) => {
                        return (
                          <div className="pt-2">
                            <div className="pb-2">
                              {v?.name}({v?.conversion})
                            </div>
                            <div>
                              <div className="border border-gray-300 p-1 rounded-md">
                                <div>{v?.unit_delivered}</div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </td> */}
                  {/* <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td> */}
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td
                    className="border border-gray-200 border-b-gray-400 p-4 text-center"
                    colSpan={1}
                  ></td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td className="border p-4" rowSpan={2} colSpan={6}></td>
            <td className="border p-4" rowSpan={2} colSpan={3}>
              <div className="text-center">
                <AddButton
                  className={"form-save-button w-full h-full text-center"}
                  onClick={handleAdd}
                />
              </div>
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-gray-700">SUBTOTAL</td>
            <td className="border p-4" colSpan={2}>
              {totals?.subtotal > 0 ? totals?.subtotal?.toFixed(3) : "0.000"}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-gray-700">TAX&nbsp;[VAT]</td>
            <td className="border p-4" colSpan={2}>
              {totals?.taxamount > 0 ? totals?.taxamount?.toFixed(3) : "0.000"}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-gray-700">DISCOUNT&nbsp;</td>
            <td className="border p-4" colSpan={2}>
              <Input
                type="number"
                className="w-full"
                placeholder="Discount amount"
                name="discount"
                value={totals?.discount}
                autoComplete="off"
                onChange={handleDiscount}
                onKeyDown={(e) => {
                  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                    e.preventDefault();
                  }
                }}
                onWheel={(e) => {
                  e.target.blur();
                }}
              />
            </td>
          </tr>
          {/* <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-gray-700">DELIVERY&nbsp;CHARGES</td>
            <td className="border p-4" colSpan={2}>
              <Input
                type="number"
                className="w-full"
                placeholder="Delivery charges"
                name="delivery"
                value={totals?.delivery}
                autoComplete="off"
                onChange={handleDelivery}
              />
            </td>
          </tr> */}
          <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-gray-700">REFERENCE</td>
            <td className="border p-4" colSpan={2}>
              {/* <Input
                type="text"
                className="w-full"
                placeholder="Reference"
                name="reference"
                // value={totals?.delivery}
                autoComplete="off"
                // onChange={handleDelivery}
              /> */}
              <Select
                className="w-full text-regular"
                name="reference"
                showSearch
                allowClear
                placeholder="Select Reference"
                filterOption={false}
                // onSearch={(e) => handleCustomerSearch(e)}
                // onClick={(e) => handleCustomerSearch("")}
                // onFocus={(e) => handleCustomerSearch("")}
                // onChange={(e) => setCustomer(e)}
                onSearch={(e) => handleReferenceSearch(e)}
                onClick={(e) => handleReferenceSearch("")}
                onFocus={(e) => handleReferenceSearch("")}
                onChange={(e) => setReference(e)}
                options={referenceOptions}
              />
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-gray-700">CUSTOMER</td>
            <td className="border p-4" colSpan={2}>
              <div className="">
                <div>
                  <Select
                    className="w-full text-regular"
                    name="customer"
                    showSearch
                    allowClear
                    placeholder="Select customer"
                    filterOption={false}
                    onSearch={(e) => handleCustomerSearch(e)}
                    onClick={(e) => handleCustomerSearch("")}
                    onFocus={(e) => handleCustomerSearch("")}
                    onChange={(e) => setCustomer(e)}
                    options={customerOptions}
                  />
                </div>
                <div className="flex w-full pt-4">
                  <div className="w-full">
                    <Input
                      className="w-full text-regular"
                      name="name"
                      value={customerName}
                      placeholder="Name"
                      onChange={handleCustomer}
                      autoComplete="off"
                    />
                  </div>
                  <div className="w-full pl-2">
                    <Input
                      className="w-full text-regular"
                      name="phone"
                      value={customerPhone}
                      placeholder="Phone"
                      onChange={handleCustomer}
                      autoComplete="off"
                    />
                  </div>
                  <div>
                    <Button
                      type="button"
                      className="w-full text-medium text-white bg-[#07B553] hover:bg-[#14532d] mx-1"
                      onClick={addCustomer}
                    >
                      ADD
                    </Button>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-gray-700">PAYMENT&nbsp;STATUS</td>
            <td className="border p-4" colSpan={2}>
              <div>
                <Select
                  className="w-full"
                  name="tax"
                  placeholder="Payment status"
                  value={totals?.payment_status}
                  options={[
                    {
                      value: 0,
                      label: "Unpaid",
                    },
                    {
                      value: 1,
                      label: "Partial",
                    },
                    {
                      value: 2,
                      label: "Paid",
                    },
                  ]}
                  onChange={handlePaymentStatus}
                />
              </div>
              {totals?.payment_status == 1 || totals?.payment_status == 2 ? (
                <div className="pt-4">
                  <Select
                    mode="multiple"
                    className="w-full"
                    name="payment_types"
                    ref={focus.current[`payment_types`]}
                    placeholder="Payment types"
                    value={totals?.payment_types}
                    options={payment_types}
                    onChange={handlePaymentTypes}
                  />
                  <Error id={`payment_types`} />
                </div>
              ) : (
                ""
              )}

              {totals?.payment_types?.length > 1 ? (
                <div className="text-green-500 flex justify-between pt-3">
                  <div>PENDING :</div>
                  <div>{totals.pending_payment?.toFixed?.(3)}</div>
                </div>
              ) : (
                ""
              )}

              {totals?.payment_types?.map((value, index) => {
                focus.current[`${value}`] = createRef();
                return totals?.payment_types?.length <= 1 &&
                  totals?.payment_status == 2 ? (
                  ""
                ) : (
                  <div>
                    <div className="pt-4">
                      <Input
                        type="number"
                        className="w-full"
                        placeholder={value}
                        name={value}
                        ref={focus.current[`${value}`]}
                        value={totals?.payments?.[value]?.amount}
                        onChange={handlePayments}
                        autoComplete="off"
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => {
                          e.target.blur();
                        }}
                      />
                      <Error id={`${value}`} />
                    </div>
                  </div>
                );
              })}
              {/* {totals?.payment_types?.map((value, index) => {
                focus.current[`${value}`] = createRef();
                return (
                  <div className="pt-4">
                    <Input
                      type="number"
                      className="w-full"
                      placeholder={value}
                      name={value}
                      ref={focus.current[`${value}`]}
                      value={totals?.payments?.[value]?.amount}
                      onChange={handlePayments}
                      autoComplete="off"
                    />
                    <Error id={`${value}`} />
                  </div>
                );
              })} */}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-gray-700">PAYMENT&nbsp;BALANCE</td>
            <td className="border p-4" colSpan={2}>
              <div className="">
                <div className="flex w-full">
                  <div className="w-full">
                    <Input
                      size=""
                      className="w-full text-regular"
                      name="number"
                      value={customerPay}
                      placeholder="Customer cash pay"
                      onChange={handleCustomerPay}
                      autoComplete="off"
                    />
                  </div>
                </div>
                {totals?.payment_types?.length > 0 && (
                  <div className="flex justify-between w-full pt-3">
                    <div className="text-medium text-gray-500">
                      RETURN BALANCE&nbsp;&nbsp;
                    </div>
                    <div className="text-medium text-gray-500">
                      {totals?.payment_types[0] === "Cash" &&
                        totals?.payment_types?.length === 1 &&
                        parseFloat(customerPay || 0) > 0
                        ? "OMR " +
                        (
                          parseFloat(customerPay || 0) -
                          parseFloat(totals?.total || 0)
                        ).toFixed(3)
                        : ""}
                    </div>
                  </div>
                )}

              </div>
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-black text-medium">TOTAL</td>
            <td className="border p-4 text-black text-medium" colSpan={2}>
              {totals?.total > 0 ? totals?.total?.toFixed(3) : "0.000"}
            </td>
          </tr>
        </tfoot>
      </table>
      {/* <div className="flex justify-end p-3">
        <AddButton onClick={handleAdd} />
      </div> */}
    </div>
  );
});

export default BillingTable;
